module.exports = __webpack_public_path__ + "img/rateLev_4.b575867e.svg";